function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var LabelElement = _ref => {
  var id = _ref.id,
    label = _ref.label,
    required = _ref.required,
    visualState = _ref.visualState,
    getLabelProps = _ref.getLabelProps,
    styles = _ref.styles;
  return ___EmotionJSX("label", _extends({
    css: styles.label(visualState),
    htmlFor: "".concat(id, "-input")
  }, getLabelProps()), label, required && ___EmotionJSX("span", {
    className: "input-wrapper__required",
    css: styles.required,
    role: "presentation",
    "aria-hidden": true
  }, "*"));
};